import { useContext, useEffect, useState } from "react";
import Context from "../../../../common/components/utils/context";
import { IShapeFile } from "../../../earthtwin/models";
import Moment from "react-moment";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { notifcation } from "../../../../common/components/utils/notifications";
import { Themes } from "../../../../common/enums/themes";
import { ShapeFilesV1Service } from "../../../../common/services/api/api";

export const ShapeFiles = () => {
  const context = useContext(Context);

  const [update, setUpdate] = useState(true);
  const [selected, setSelected] = useState<IShapeFile>();
  const [shapeFiles, setShapeFiles] = useState<IShapeFile[]>([]);

  useEffect(() => {
    setShapeFiles(context.shapeFiles);
  }, []);

  useEffect(() => {
    if (update) {
      loadShapeFiles().then(() => setUpdate(false));
    }
  }, [update]);

  const loadShapeFiles = async () => {
    const shapeFilesService = new ShapeFilesV1Service();
    const response = await shapeFilesService.getShapeFiles();
    setShapeFiles(response.data);
  };

  const remove = async (item: IShapeFile) => {
    const confirm = await notifcation({
      title: "Confirm Delete",
      message: `Are your sure you want to delete ${item.displayName} ?`,
      cancel: "Cancel",
      confirm: "Delete",
    });
    if (confirm) {
      const shapeFilesService = new ShapeFilesV1Service();

      const response = await shapeFilesService.deleteShapeFile(item.id);
      if (response.status === 204) {
        setUpdate(true);
        context.setAlert({
          message: "Shape File deleted successfully!",
          theme: Themes.Success,
        });
      } else {
        context.setAlert({
          message: "Failed to delete Shape File!",
          theme: Themes.Danger,
        });
      }
    }
  };

  return (
    <div className="border rounded-lg">
      <table className="border-collapse table-auto w-full text-sm">
        <thead>
          <tr>
            <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
              <div className="flex flex-row space-x-2 items-center">
                Description
              </div>
            </th>
            <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
              <div className="flex flex-row space-x-2 items-center">Date</div>
            </th>
            <th
              className="border-b font-medium p-4 py-3 text-slate-400 text-left"
              colSpan={2}
            >
              <div className="flex flex-row space-x-2 items-center">
                Actions
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {shapeFiles.map((item: IShapeFile) => (
            <tr
              key={item.id}
              className="cursor-pointer border-b last-of-type:border-b-0 hover:bg-gray-50"
              onClick={() => setSelected(item)}
            >
              <td className="border-r p-4 text-slate-500">
                {item.displayName}
              </td>
              <td className="border-r last-of-type:border-r-0 p-4 text-slate-500">
                <Moment date={item.created} format="DD/MM/YYYY" />
              </td>
              <td
                className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-red-400"
                onClick={() => remove(item)}
              >
                <MdDeleteForever size={20} title="Delete" className="mx-auto" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
